module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticStyle: {
      "padding-top": "15px",
      "padding-bottom": "14px",
      "border-bottom": "1px solid rgb(209, 219, 229)"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('label', {
    staticStyle: {
      "width": "80px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("所属系统:")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "全部"
    },
    model: {
      value: (_vm.filterForm.sysCode),
      callback: function($$v) {
        _vm.$set(_vm.filterForm, "sysCode", $$v)
      },
      expression: "filterForm.sysCode"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": "all"
    }
  }), _vm._v(" "), _vm._l((_vm.sysAppList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  })], 2), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "80px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("所属项目:")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "请选择项目",
      "suffix-icon": "el-icon-date"
    },
    on: {
      "focus": _vm.showProjectTree
    },
    model: {
      value: (_vm.projectNames),
      callback: function($$v) {
        _vm.projectNames = $$v
      },
      expression: "projectNames"
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "项目归属"
    },
    model: {
      value: (_vm.projectTreeDialogVisible),
      callback: function($$v) {
        _vm.projectTreeDialogVisible = $$v
      },
      expression: "projectTreeDialogVisible"
    }
  }, [_c('div', {}, [_c('el-input', {
    attrs: {
      "placeholder": "输入关键字进行过滤"
    },
    model: {
      value: (_vm.filterText),
      callback: function($$v) {
        _vm.filterText = $$v
      },
      expression: "filterText"
    }
  }), _vm._v(" "), _c('el-tree', {
    ref: "projectTree",
    staticClass: "filter-tree",
    attrs: {
      "data": _vm.projectTree,
      "show-checkbox": "",
      "node-key": "id",
      "default-checked-keys": _vm.projectTreeDefaultChecked,
      "filter-node-method": _vm.filterNode
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.projectTreeOnCancel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.projectTreeOnSubmit
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "80px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("点类型:")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    model: {
      value: (_vm.filterForm.deviceModel),
      callback: function($$v) {
        _vm.$set(_vm.filterForm, "deviceModel", $$v)
      },
      expression: "filterForm.deviceModel"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": "all"
    }
  }), _vm._v(" "), _vm._l((_vm.deviceModelList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  })], 2), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "80px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("点搜索:")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "输入点名称/编号"
    },
    model: {
      value: (_vm.filterForm.search_word),
      callback: function($$v) {
        _vm.$set(_vm.filterForm, "search_word", $$v)
      },
      expression: "filterForm.search_word"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "15px"
    },
    on: {
      "click": function($event) {
        _vm.queryBtn()
      }
    }
  }, [_vm._v("查询")])], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding": "0px",
      "padding-bottom": "2px",
      "margin": "5px 0px"
    },
    attrs: {
      "span": 24
    }
  }, [(_vm.permissionNodeList.terminal_add.hasEntitle == 1) ? _c('el-button', {
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增传感器")]) : _vm._e(), _vm._v(" "), (_vm.permissionNodeList.terminal_del.hasEntitle == 1) ? _c('el-button', {
    on: {
      "click": _vm.handleBatchDelete
    }
  }, [_vm._v("删除传感器")]) : _vm._e(), _vm._v(" "), (_vm.permissionNodeList.terminal_import.hasEntitle == 1) ? _c('el-button', {
    on: {
      "click": _vm.handleBatchImport
    }
  }, [_vm._v("批量导入")]) : _vm._e(), _vm._v(" "), (_vm.permissionNodeList.terminal_export.hasEntitle == 1) ? _c('el-button', {
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("数据导出")]) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量导入项目"
    },
    on: {
      "close": _vm.cancelUpload
    },
    model: {
      value: (_vm.batchImportDialogVisible),
      callback: function($$v) {
        _vm.batchImportDialogVisible = $$v
      },
      expression: "batchImportDialogVisible"
    }
  }, [_c('el-upload', {
    ref: "batchImportUpload",
    attrs: {
      "limit": 1,
      "on-exceed": _vm.handleUploadExceed,
      "action": _vm.uploadUrl,
      "on-success": _vm.handleUploadSuccess,
      "on-error": _vm.handleUploadError,
      "before-upload": _vm.handleBeforeUpload,
      "headers": _vm.uploadHeader,
      "auto-upload": false
    }
  }, [_c('span', [_vm._v("选取文件:    ")]), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("请选择")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "display": "inline",
      "padding-left": "350px",
      "color": "#b0b1b3",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.downloadTemplate($event)
      }
    }
  }, [_vm._v("模版下载")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    staticStyle: {
      "margin-top": "55px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("温馨提示:只能上传excel文件，且不超过20MB")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelUpload
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchImportOnSubmit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list_data,
      "size": "mini",
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "projectName",
      "label": "所属项目",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "传感器名称",
      "width": "160",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sn",
      "label": "传感器编号",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deviceModelName",
      "label": "传感器类型",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "routeNum",
      "label": "路数",
      "width": "80",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "传感器地址",
      "width": "140",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sysCodeName",
      "label": "系统类型",
      "min-width": "90",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "280"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.alarmIgnoreAble == '0' && _vm.permissionNodeList.terminal_shield.hasEntitle == 1) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleBlock(scope.$index, scope.row)
            }
          }
        }, [_vm._v("屏蔽")]) : _vm._e(), _vm._v(" "), (scope.row.alarmIgnoreAble == '1' && _vm.permissionNodeList.terminal_shield.hasEntitle == 1) ? _c('el-button', {
          staticStyle: {
            "color": "#b0b1b3"
          },
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleUnBlock(scope.$index, scope.row)
            }
          }
        }, [_vm._v("已屏蔽")]) : _vm._e(), _vm._v(" "), (_vm.permissionNodeList.terminal_conf.hasEntitle == 1 && scope.row.deviceModel != 'ECSLZT') ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleSetting(scope.$index, scope.row)
            }
          }
        }, [_vm._v("配置")]) : _vm._e(), _vm._v(" "), (_vm.permissionNodeList.terminal_show.hasEntitle == 1 && scope.row.deviceModel != 'ECSLZT') ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleShowSetting(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看配置")]) : _vm._e(), _vm._v(" "), (_vm.permissionNodeList.terminal_edit.hasEntitle == 1) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("修改")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 15,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增传感器",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.cancelAddSubmit
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "120px",
      "rules": _vm.saveFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "传感器名称"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "sn",
      "label": "传感器编号"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.sn),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "sn", $$v)
      },
      expression: "addForm.sn"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "address",
      "label": "传感器地址"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.address),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "address", $$v)
      },
      expression: "addForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "versionNumber",
      "label": "传感器版本"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.versionNumber),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "versionNumber", $$v)
      },
      expression: "addForm.versionNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "传感器类型",
      "prop": "deviceModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.addForm.deviceModel),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "deviceModel", $$v)
      },
      expression: "addForm.deviceModel"
    }
  }, _vm._l((_vm.deviceModelList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  }))], 1), _vm._v(" "), ((_vm.addForm.deviceModel == 'D4ACZT-T') || (_vm.addForm.deviceModel == 'D4ACZT')) ? _c('el-form-item', {
    attrs: {
      "prop": "rangeUpper",
      "label": "量程上限"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.rangeUpper),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "rangeUpper", $$v)
      },
      expression: "addForm.rangeUpper"
    }
  }), _vm._v(" "), (_vm.addForm.deviceModel == 'D4ACZT-T') ? _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("℃")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.addForm.deviceModel == 'D4ACZT-T' || (_vm.addForm.deviceModel == 'D4ACZT')) ? _c('el-form-item', {
    attrs: {
      "prop": "rangeLower",
      "label": "量程下限"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.rangeLower),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "rangeLower", $$v)
      },
      expression: "addForm.rangeLower"
    }
  }), _vm._v(" "), (_vm.addForm.deviceModel == 'D4ACZT-T') ? _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("℃")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.addForm.deviceModel == 'OC16ZT') ? _c('el-form-item', {
    attrs: {
      "prop": "routeNum",
      "label": "路数"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.routeNum),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "routeNum", $$v)
      },
      expression: "addForm.routeNum"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "1",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "2",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "3",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "4",
      "value": "4"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "5",
      "value": "5"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "6",
      "value": "6"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "7",
      "value": "7"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "8",
      "value": "8"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "9",
      "value": "9"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "10",
      "value": "10"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "11",
      "value": "11"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "12",
      "value": "12"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "13",
      "value": "13"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "14",
      "value": "14"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "15",
      "value": "15"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addForm.deviceModel == 'D4ACZT') ? _c('el-form-item', {
    attrs: {
      "prop": "unit",
      "label": "单位"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.unit),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "unit", $$v)
      },
      expression: "addForm.unit"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属项目",
      "prop": "projectId"
    }
  }, [_c('div', [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.projectId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "projectId", $$v)
      },
      expression: "addForm.projectId"
    }
  }, _vm._l((_vm.projectList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)]), _vm._v(" "), (_vm.addForm.deviceModel != 'ECSLZT') ? _c('el-form-item', {
    attrs: {
      "label": "系统类型",
      "prop": "sysCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.sysCode),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "sysCode", $$v)
      },
      expression: "addForm.sysCode"
    }
  }, _vm._l((_vm.sysAppList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.addForm.deviceModel == 'ECSLZT') ? _c('el-form-item', {
    attrs: {
      "prop": "sysCode",
      "label": "系统类型"
    }
  }, [_c('treeselect', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "multiple": true,
      "options": _vm.sysAppListForTree,
      "valueFormat": "id",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.sysCode),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "sysCode", $$v)
      },
      expression: "addForm.sysCode"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelAddSubmit($event)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.addSubmitButtonDisabled,
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑传感器",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px",
      "rules": _vm.saveFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "传感器名称"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "sn",
      "label": "传感器编号"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "disabled": ""
    },
    model: {
      value: (_vm.editForm.sn),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "sn", $$v)
      },
      expression: "editForm.sn"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "address",
      "label": "传感器地址"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.address),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "address", $$v)
      },
      expression: "editForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "versionNumber",
      "label": "传感器版本"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.versionNumber),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "versionNumber", $$v)
      },
      expression: "editForm.versionNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "传感器类型",
      "prop": "deviceModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.editForm.deviceModel),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "deviceModel", $$v)
      },
      expression: "editForm.deviceModel"
    }
  }, _vm._l((_vm.deviceModelList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  }))], 1), _vm._v(" "), ((_vm.editForm.deviceModel == 'D4ACZT-T') || (_vm.editForm.deviceModel == 'D4ACZT')) ? _c('el-form-item', {
    attrs: {
      "prop": "rangeUpper",
      "label": "量程上限"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.rangeUpper),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "rangeUpper", $$v)
      },
      expression: "editForm.rangeUpper"
    }
  }), _vm._v(" "), (_vm.addForm.deviceModel == 'D4ACZT-T') ? _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("℃")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), ((_vm.editForm.deviceModel == 'D4ACZT-T') || (_vm.editForm.deviceModel == 'D4ACZT')) ? _c('el-form-item', {
    attrs: {
      "prop": "rangeLower",
      "label": "量程下限"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.rangeLower),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "rangeLower", $$v)
      },
      expression: "editForm.rangeLower"
    }
  }), _vm._v(" "), (_vm.addForm.deviceModel == 'D4ACZT-T') ? _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("℃")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.editForm.deviceModel == 'OC16ZT') ? _c('el-form-item', {
    attrs: {
      "prop": "routeNum",
      "label": "路数"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editForm.routeNum),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "routeNum", $$v)
      },
      expression: "editForm.routeNum"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "1",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "2",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "3",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "4",
      "value": "4"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "5",
      "value": "5"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "6",
      "value": "6"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "7",
      "value": "7"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "8",
      "value": "8"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "9",
      "value": "9"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "10",
      "value": "10"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "11",
      "value": "11"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "12",
      "value": "12"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "13",
      "value": "13"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "14",
      "value": "14"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "15",
      "value": "15"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.editForm.deviceModel == 'D4ACZT') ? _c('el-form-item', {
    attrs: {
      "prop": "unit",
      "label": "单位"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.unit),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "unit", $$v)
      },
      expression: "editForm.unit"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属项目",
      "prop": "projectId"
    }
  }, [_c('div', [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editForm.projectId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "projectId", $$v)
      },
      expression: "editForm.projectId"
    }
  }, _vm._l((_vm.projectList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)]), _vm._v(" "), (_vm.editForm.deviceModel != 'ECSLZT') ? _c('el-form-item', {
    attrs: {
      "label": "系统类型",
      "prop": "sysCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editForm.sysCode),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "sysCode", $$v)
      },
      expression: "editForm.sysCode"
    }
  }, _vm._l((_vm.sysAppList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.editForm.deviceModel == 'ECSLZT') ? _c('el-form-item', {
    attrs: {
      "prop": "sysCode",
      "label": "系统类型"
    }
  }, [_c('treeselect', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "multiple": true,
      "options": _vm.sysAppListForTree,
      "valueFormat": "id",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editForm.sysCode),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "sysCode", $$v)
      },
      expression: "editForm.sysCode"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false;
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.editSubmitButtonDisabled,
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "屏蔽",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.cancelBlockSubmit
    },
    model: {
      value: (_vm.blockFormVisible),
      callback: function($$v) {
        _vm.blockFormVisible = $$v
      },
      expression: "blockFormVisible"
    }
  }, [_c('el-form', {
    ref: "blockForm",
    attrs: {
      "model": _vm.blockForm,
      "label-width": "120px",
      "rules": _vm.blockFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "传感器名称"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.blockForm.name))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "传感器类型:",
      "prop": "deviceModelName"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.blockForm.deviceModelName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "屏蔽开始时间",
      "prop": "startTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "value-format": "yyyy-MM-dd HH:mm",
      "format": "yyyy-MM-dd HH:mm",
      "type": "datetime"
    },
    model: {
      value: (_vm.blockForm.startTime),
      callback: function($$v) {
        _vm.$set(_vm.blockForm, "startTime", $$v)
      },
      expression: "blockForm.startTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "屏蔽结束时间",
      "prop": "endTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "value-format": "yyyy-MM-dd HH:mm",
      "format": "yyyy-MM-dd HH:mm",
      "type": "datetime"
    },
    model: {
      value: (_vm.blockForm.endTime),
      callback: function($$v) {
        _vm.$set(_vm.blockForm, "endTime", $$v)
      },
      expression: "blockForm.endTime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelBlockSubmit($event)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.blockSubmitButtonDisabled,
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.blockSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "配置",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.cancelSettingSubmit
    },
    model: {
      value: (_vm.settingFormVisible),
      callback: function($$v) {
        _vm.settingFormVisible = $$v
      },
      expression: "settingFormVisible"
    }
  }, [_c('el-form', {
    ref: "settingForm",
    attrs: {
      "model": _vm.settingForm,
      "label-width": "120px",
      "rules": _vm.settingFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "传感器名称:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.settingForm.name))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "传感器类型:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.settingForm.deviceModelName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数据类型:",
      "prop": "dataType"
    }
  }, [(_vm.settingForm.dataType == 0) ? _c('span', [_vm._v("AI")]) : _c('span', [_vm._v("DI")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "告警:",
      "prop": "alarmType"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.settingForm.deviceModel == 'DMZ3ZT'
    },
    model: {
      value: (_vm.settingForm.alarmType),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "alarmType", $$v)
      },
      expression: "settingForm.alarmType"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("报警")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": -1
    }
  }, [_vm._v("预警")]), _vm._v(" "), (_vm.settingForm.dataType == '0') ? _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("预警+报警")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.settingForm.dataType == 0) ? _c('el-form-item', {
    attrs: {
      "label": "告警参数:",
      "prop": "thresholdType"
    }
  }, [(_vm.settingForm.deviceModel == 'YS-ZN-004-VOC') ? _c('el-checkbox', {
    model: {
      value: (_vm.settingForm.thresholdType),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "thresholdType", $$v)
      },
      expression: "settingForm.thresholdType"
    }
  }, [_vm._v("TVOC (ppm)")]) : _vm._e(), _vm._v(" "), (_vm.settingForm.deviceModel == 'YS-ZN-010-NH3' || _vm.settingForm.deviceModel == 'YS-ZN-009-CO') ? _c('el-checkbox', {
    model: {
      value: (_vm.settingForm.thresholdType),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "thresholdType", $$v)
      },
      expression: "settingForm.thresholdType"
    }
  }, [_vm._v("ppm")]) : _vm._e(), _vm._v(" "), (_vm.settingForm.deviceModel == 'YS-ZN-002-CO2' || _vm.settingForm.deviceModel == 'YS-ZN-012-H2S') ? _c('el-checkbox', {
    model: {
      value: (_vm.settingForm.thresholdType),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "thresholdType", $$v)
      },
      expression: "settingForm.thresholdType"
    }
  }, [_vm._v("%")]) : _vm._e(), _vm._v(" "), (_vm.settingForm.deviceModel == 'THZ2ZT') ? _c('el-checkbox', {
    model: {
      value: (_vm.settingForm.thresholdType),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "thresholdType", $$v)
      },
      expression: "settingForm.thresholdType"
    }
  }, [_vm._v("温度（℃）")]) : _vm._e(), _vm._v(" "), (_vm.settingForm.deviceModel == 'VBZ3ZT' && _vm.settingForm.versionNumber == '5') ? _c('el-checkbox', {
    model: {
      value: (_vm.settingForm.thresholdType),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "thresholdType", $$v)
      },
      expression: "settingForm.thresholdType"
    }
  }, [_vm._v("频率（Hz）")]) : _vm._e(), _vm._v(" "), (_vm.settingForm.deviceModel == 'VBZ3ZT' && _vm.settingForm.versionNumber == '0') ? _c('el-radio-group', {
    model: {
      value: (_vm.settingForm.thresholdType),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "thresholdType", $$v)
      },
      expression: "settingForm.thresholdType"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "checked": "",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.settingForm.thresholdTypeName))])], 1) : _vm._e(), _vm._v(" "), (_vm.settingForm.deviceModel != 'THZ2ZT' && _vm.settingForm.deviceModel != 'VBZ3ZT') ? _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.settingForm.thresholdTypeName))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.settingForm.dataType == '0' && (_vm.settingForm.alarmType == '0' || _vm.settingForm.alarmType == '-1' || _vm.settingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.lowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "lowerThreshold", $$v)
      },
      expression: "settingForm.lowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.upperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "upperThreshold", $$v)
      },
      expression: "settingForm.upperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.settingForm.dataType == '0' && _vm.settingForm.alarmType == '1') ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.earlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "earlyLowerThreshold", $$v)
      },
      expression: "settingForm.earlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.earlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "earlyUpperThreshold", $$v)
      },
      expression: "settingForm.earlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.settingForm.deviceModel == 'THZ2ZT') || (_vm.settingForm.deviceModel == 'VBZ3ZT' && _vm.settingForm.versionNumber == '5')) ? _c('el-form-item', {
    attrs: {
      "label": "告警参数:",
      "prop": "otherThresholdType"
    }
  }, [(_vm.settingForm.deviceModel == 'THZ2ZT') ? _c('el-checkbox', {
    model: {
      value: (_vm.settingForm.otherThresholdType),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "otherThresholdType", $$v)
      },
      expression: "settingForm.otherThresholdType"
    }
  }, [_vm._v("湿度（%）")]) : _vm._e(), _vm._v(" "), (_vm.settingForm.deviceModel == 'VBZ3ZT' && _vm.settingForm.versionNumber == '5') ? _c('el-checkbox', {
    model: {
      value: (_vm.settingForm.otherThresholdType),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "otherThresholdType", $$v)
      },
      expression: "settingForm.otherThresholdType"
    }
  }, [_vm._v("熵值")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.settingForm.deviceModel == 'THZ2ZT' || (_vm.settingForm.deviceModel == 'VBZ3ZT' && _vm.settingForm.versionNumber == '5') && (_vm.settingForm.alarmType == '0' || _vm.settingForm.alarmType == '-1' || _vm.settingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.otherLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "otherLowerThreshold", $$v)
      },
      expression: "settingForm.otherLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.otherUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "otherUpperThreshold", $$v)
      },
      expression: "settingForm.otherUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.settingForm.deviceModel == 'THZ2ZT' || (_vm.settingForm.deviceModel == 'VBZ3ZT' && _vm.settingForm.versionNumber == '5')) && (_vm.settingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.otherEarlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "otherEarlyLowerThreshold", $$v)
      },
      expression: "settingForm.otherEarlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.otherEarlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "otherEarlyUpperThreshold", $$v)
      },
      expression: "settingForm.otherEarlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.settingForm.dataType == '1' && _vm.settingForm.deviceModel != 'OCZ1ZT47-XY') ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "状态说明",
      "prop": "explainModel"
    }
  }, [_c('span', [_vm._v("0:")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": _vm.settingForm.deviceModel == 'DMZ3ZT',
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.zeroExplain),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "zeroExplain", $$v)
      },
      expression: "settingForm.zeroExplain"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_vm._v("1:")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": _vm.settingForm.deviceModel == 'DMZ3ZT',
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.oneExplain),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "oneExplain", $$v)
      },
      expression: "settingForm.oneExplain"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.settingForm.deviceModel == 'OCZ1ZT47-XY') ? _c('el-form-item', {
    attrs: {
      "label": "状态说明",
      "prop": "explainModel"
    }
  }, [_c('span', [_vm._v("有人吸烟:")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.settingForm.oneExplain),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "oneExplain", $$v)
      },
      expression: "settingForm.oneExplain"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "通",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "断",
      "value": "0"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.settingForm.dataType == '1' && _vm.settingForm.deviceModel != 'OCZ1ZT47-XY') ? _c('el-form-item', {
    attrs: {
      "label": "报警状态",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": _vm.settingForm.deviceModel == 'DMZ3ZT',
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.settingForm.explainModel),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "explainModel", $$v)
      },
      expression: "settingForm.explainModel"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "无",
      "value": "-1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "0",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "1",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "01",
      "value": "2"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.settingForm.deviceModel == 'OCZ1ZT47-XY') ? _c('el-form-item', {
    attrs: {
      "label": "报警状态",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.settingForm.explainModel),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "explainModel", $$v)
      },
      expression: "settingForm.explainModel"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不开启",
      "value": "-1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "开启",
      "value": "1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "alarmTimeout",
      "label": "告警超时:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入1-3000的自然数"
    },
    model: {
      value: (_vm.settingForm.alarmTimeout),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "alarmTimeout", $$v)
      },
      expression: "settingForm.alarmTimeout"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("分钟")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelSettingSubmit($event)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.userRoleIdentity == 'admin') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.settingSubmitButtonDisabled,
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.settingSubmit($event)
      }
    }
  }, [_vm._v("提交")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看配置",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.cancelShowSettingSubmit
    },
    model: {
      value: (_vm.showSettingFormVisible),
      callback: function($$v) {
        _vm.showSettingFormVisible = $$v
      },
      expression: "showSettingFormVisible"
    }
  }, [_c('el-form', {
    ref: "settingForm",
    attrs: {
      "model": _vm.settingForm,
      "label-width": "120px",
      "rules": _vm.settingFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "传感器名称:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.settingForm.name))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "传感器类型:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.settingForm.deviceModelName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数据类型:",
      "prop": "dataType"
    }
  }, [(_vm.settingForm.dataType == 0) ? _c('span', [_vm._v("AI")]) : _c('span', [_vm._v("DI")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "告警:",
      "prop": "alarmType"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.settingForm.alarmType),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "alarmType", $$v)
      },
      expression: "settingForm.alarmType"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("报警")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": -1
    }
  }, [_vm._v("预警")]), _vm._v(" "), (_vm.settingForm.dataType == '0') ? _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("预警+报警")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "告警参数:",
      "prop": "thresholdType"
    }
  }, [(_vm.settingForm.deviceModel == 'YS-ZN-004-VOC') ? _c('el-checkbox', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.settingForm.thresholdType),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "thresholdType", $$v)
      },
      expression: "settingForm.thresholdType"
    }
  }, [_vm._v("TVOC (ppm)")]) : _vm._e(), _vm._v(" "), (_vm.settingForm.deviceModel == 'THZ2ZT') ? _c('el-checkbox', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.settingForm.thresholdType),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "thresholdType", $$v)
      },
      expression: "settingForm.thresholdType"
    }
  }, [_vm._v("温度（℃）")]) : _vm._e(), _vm._v(" "), (_vm.settingForm.deviceModel == 'VBZ3ZT' && _vm.settingForm.versionNumber == '5') ? _c('el-checkbox', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.settingForm.thresholdType),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "thresholdType", $$v)
      },
      expression: "settingForm.thresholdType"
    }
  }, [_vm._v("频率（Hz）")]) : _vm._e(), _vm._v(" "), (_vm.settingForm.deviceModel == 'VBZ3ZT' && _vm.settingForm.versionNumber == '0') ? _c('el-radio-group', {
    model: {
      value: (_vm.settingForm.thresholdType),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "thresholdType", $$v)
      },
      expression: "settingForm.thresholdType"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "checked": "",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.settingForm.thresholdTypeName))])], 1) : _vm._e(), _vm._v(" "), (_vm.settingForm.deviceModel != 'THZ2ZT' && _vm.settingForm.deviceModel != 'VBZ3ZT') ? _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "checked": "",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.settingForm.thresholdTypeName))]) : _vm._e()], 1), _vm._v(" "), (_vm.settingForm.dataType == '0' && (_vm.settingForm.alarmType == '0' || _vm.settingForm.alarmType == '-1' || _vm.settingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.lowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "lowerThreshold", $$v)
      },
      expression: "settingForm.lowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.upperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "upperThreshold", $$v)
      },
      expression: "settingForm.upperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.settingForm.dataType == '0' && _vm.settingForm.alarmType == '1') ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.earlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "earlyLowerThreshold", $$v)
      },
      expression: "settingForm.earlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.earlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "earlyUpperThreshold", $$v)
      },
      expression: "settingForm.earlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.settingForm.deviceModel == 'THZ2ZT') || (_vm.settingForm.deviceModel == 'VBZ3ZT' && _vm.settingForm.versionNumber == '5')) ? _c('el-form-item', {
    attrs: {
      "label": "告警参数:",
      "prop": "otherThresholdType"
    }
  }, [(_vm.settingForm.deviceModel == 'THZ2ZT') ? _c('el-checkbox', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.settingForm.otherThresholdType),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "otherThresholdType", $$v)
      },
      expression: "settingForm.otherThresholdType"
    }
  }, [_vm._v("湿度（%）")]) : _vm._e(), _vm._v(" "), (_vm.settingForm.deviceModel == 'VBZ3ZT' && _vm.settingForm.versionNumber == '5') ? _c('el-checkbox', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.settingForm.otherThresholdType),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "otherThresholdType", $$v)
      },
      expression: "settingForm.otherThresholdType"
    }
  }, [_vm._v("熵值")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.settingForm.deviceModel == 'THZ2ZT' || (_vm.settingForm.deviceModel == 'VBZ3ZT' && _vm.settingForm.versionNumber == '5') && (_vm.settingForm.alarmType == '0' || _vm.settingForm.alarmType == '-1' || _vm.settingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.otherLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "otherLowerThreshold", $$v)
      },
      expression: "settingForm.otherLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.otherUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "otherUpperThreshold", $$v)
      },
      expression: "settingForm.otherUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.settingForm.deviceModel == 'THZ2ZT' || (_vm.settingForm.deviceModel == 'VBZ3ZT' && _vm.settingForm.versionNumber == '5')) && (_vm.settingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.otherEarlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "otherEarlyLowerThreshold", $$v)
      },
      expression: "settingForm.otherEarlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.otherEarlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "otherEarlyUpperThreshold", $$v)
      },
      expression: "settingForm.otherEarlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.settingForm.dataType == '1' && _vm.settingForm.deviceModel != 'OCZ1ZT47-XY') ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "状态说明",
      "prop": "explainModel"
    }
  }, [_c('span', [_vm._v("0:")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.zeroExplain),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "zeroExplain", $$v)
      },
      expression: "settingForm.zeroExplain"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_vm._v("1:")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.oneExplain),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "oneExplain", $$v)
      },
      expression: "settingForm.oneExplain"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.settingForm.deviceModel == 'OCZ1ZT47-XY') ? _c('el-form-item', {
    attrs: {
      "label": "状态说明",
      "prop": "explainModel"
    }
  }, [_c('span', [_vm._v("有人吸烟:")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.settingForm.oneExplain),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "oneExplain", $$v)
      },
      expression: "settingForm.oneExplain"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "通",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "断",
      "value": "0"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.settingForm.dataType == '1' && _vm.settingForm.deviceModel != 'OCZ1ZT47-XY') ? _c('el-form-item', {
    attrs: {
      "label": "报警状态",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.settingForm.explainModel),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "explainModel", $$v)
      },
      expression: "settingForm.explainModel"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "无",
      "value": "-1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "0",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "1",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "01",
      "value": "2"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.settingForm.deviceModel == 'OCZ1ZT47-XY') ? _c('el-form-item', {
    attrs: {
      "label": "报警状态",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.settingForm.explainModel),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "explainModel", $$v)
      },
      expression: "settingForm.explainModel"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不开启",
      "value": "-1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "开启",
      "value": "1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "alarmTimeout",
      "label": "告警超时:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.settingForm.alarmTimeout),
      callback: function($$v) {
        _vm.$set(_vm.settingForm, "alarmTimeout", $$v)
      },
      expression: "settingForm.alarmTimeout"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("分钟")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelShowSettingSubmit($event)
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "配置",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.cancelMultSettingSubmit
    },
    model: {
      value: (_vm.multSettingFormVisible),
      callback: function($$v) {
        _vm.multSettingFormVisible = $$v
      },
      expression: "multSettingFormVisible"
    }
  }, [_c('el-form', {
    ref: "multSettingForm",
    attrs: {
      "model": _vm.multSettingForm,
      "label-width": "160px",
      "rules": _vm.settingFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "传感器名称:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.multSettingForm.name))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "传感器类型:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.multSettingForm.deviceModelName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数据类型:",
      "prop": "dataType"
    }
  }, [(_vm.multSettingForm.dataType == 0) ? _c('span', [_vm._v("AI")]) : _c('span', [_vm._v("DI")])]), _vm._v(" "), (_vm.isYSZNDeviceType(_vm.multSettingForm.deviceModel)) ? _c('el-form-item', {
    attrs: {
      "label": "告警:",
      "prop": "alarmType"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.multSettingForm.alarmType),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm, "alarmType", $$v)
      },
      expression: "multSettingForm.alarmType"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("报警")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": -1
    }
  }, [_vm._v("预警")]), _vm._v(" "), (_vm.multSettingForm.dataType == '0') ? _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("预警+报警")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-012-H2S') ? _c('el-form-item', {
    attrs: {
      "label": "告警参数:"
    }
  }, [_c('el-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("硫化氢浓度(ppm)")])], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-012-H2S' && (_vm.multSettingForm.alarmType == '0' || _vm.multSettingForm.alarmType == '-1' || _vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multH2SSetting.lowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multH2SSetting, "lowerThreshold", $$v)
      },
      expression: "multH2SSetting.lowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multH2SSetting.upperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multH2SSetting, "upperThreshold", $$v)
      },
      expression: "multH2SSetting.upperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-012-H2S' && (_vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multH2SSetting.earlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multH2SSetting, "earlyLowerThreshold", $$v)
      },
      expression: "multH2SSetting.earlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multH2SSetting.earlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multH2SSetting, "earlyUpperThreshold", $$v)
      },
      expression: "multH2SSetting.earlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-010-NH3') ? _c('el-form-item', {
    attrs: {
      "label": "告警参数:"
    }
  }, [_c('el-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("氨气浓度(ppm)")])], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-010-NH3' && (_vm.multSettingForm.alarmType == '0' || _vm.multSettingForm.alarmType == '-1' || _vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multNH3Setting.lowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multNH3Setting, "lowerThreshold", $$v)
      },
      expression: "multNH3Setting.lowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multNH3Setting.upperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multNH3Setting, "upperThreshold", $$v)
      },
      expression: "multNH3Setting.upperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-010-NH3' && (_vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multNH3Setting.earlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multNH3Setting, "earlyLowerThreshold", $$v)
      },
      expression: "multNH3Setting.earlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multNH3Setting.earlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multNH3Setting, "earlyUpperThreshold", $$v)
      },
      expression: "multNH3Setting.earlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-009-CO') ? _c('el-form-item', {
    attrs: {
      "label": "告警参数:"
    }
  }, [_c('el-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("一氧化碳浓度(ppm)")])], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-009-CO' && (_vm.multSettingForm.alarmType == '0' || _vm.multSettingForm.alarmType == '-1' || _vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multC0Setting.lowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multC0Setting, "lowerThreshold", $$v)
      },
      expression: "multC0Setting.lowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multC0Setting.upperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multC0Setting, "upperThreshold", $$v)
      },
      expression: "multC0Setting.upperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-009-CO' && (_vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multC0Setting.earlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multC0Setting, "earlyLowerThreshold", $$v)
      },
      expression: "multC0Setting.earlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multC0Setting.earlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multC0Setting, "earlyUpperThreshold", $$v)
      },
      expression: "multC0Setting.earlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-002-CO2') ? _c('el-form-item', {
    attrs: {
      "label": "告警参数:"
    }
  }, [_c('el-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("二氧化碳浓度(ppm)")])], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-002-CO2' && (_vm.multSettingForm.alarmType == '0' || _vm.multSettingForm.alarmType == '-1' || _vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multC02Setting.lowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multC02Setting, "lowerThreshold", $$v)
      },
      expression: "multC02Setting.lowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multC02Setting.upperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multC02Setting, "upperThreshold", $$v)
      },
      expression: "multC02Setting.upperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.multSettingForm.deviceModel == 'YS-ZN-002-CO2') && (_vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multC02Setting.earlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multC02Setting, "earlyLowerThreshold", $$v)
      },
      expression: "multC02Setting.earlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multC02Setting.earlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multC02Setting, "earlyUpperThreshold", $$v)
      },
      expression: "multC02Setting.earlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-10') ? _c('el-form-item', {
    attrs: {
      "label": "告警参数:"
    }
  }, [_c('el-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("温度（℃)")])], 1) : _vm._e(), _vm._v(" "), ((_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-10') && (_vm.multSettingForm.alarmType == '0' || _vm.multSettingForm.alarmType == '-1' || _vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multHeatSetting.lowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multHeatSetting, "lowerThreshold", $$v)
      },
      expression: "multHeatSetting.lowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multHeatSetting.upperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multHeatSetting, "upperThreshold", $$v)
      },
      expression: "multHeatSetting.upperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-10') && (_vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multHeatSetting.earlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multHeatSetting, "earlyLowerThreshold", $$v)
      },
      expression: "multHeatSetting.earlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multHeatSetting.earlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multHeatSetting, "earlyUpperThreshold", $$v)
      },
      expression: "multHeatSetting.earlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-10') ? _c('el-form-item', {
    attrs: {
      "label": "告警参数:"
    }
  }, [_c('el-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("湿度（%RH）")])], 1) : _vm._e(), _vm._v(" "), ((_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-10') && (_vm.multSettingForm.alarmType == '0' || _vm.multSettingForm.alarmType == '-1' || _vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multHumiditySetting.lowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multHumiditySetting, "lowerThreshold", $$v)
      },
      expression: "multHumiditySetting.lowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multHumiditySetting.upperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multHumiditySetting, "upperThreshold", $$v)
      },
      expression: "multHumiditySetting.upperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-10') && (_vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multHumiditySetting.earlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multHumiditySetting, "earlyLowerThreshold", $$v)
      },
      expression: "multHumiditySetting.earlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multHumiditySetting.earlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multHumiditySetting, "earlyUpperThreshold", $$v)
      },
      expression: "multHumiditySetting.earlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-025' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-10') ? _c('el-form-item', {
    attrs: {
      "label": "告警参数:"
    }
  }, [_c('el-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("甲醛容度 (ppb)")])], 1) : _vm._e(), _vm._v(" "), ((_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-025' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-10') && (_vm.multSettingForm.alarmType == '0' || _vm.multSettingForm.alarmType == '-1' || _vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multArofeneSetting.lowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multArofeneSetting, "lowerThreshold", $$v)
      },
      expression: "multArofeneSetting.lowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multArofeneSetting.upperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multArofeneSetting, "upperThreshold", $$v)
      },
      expression: "multArofeneSetting.upperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-025' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-10') && (_vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multArofeneSetting.earlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multArofeneSetting, "earlyLowerThreshold", $$v)
      },
      expression: "multArofeneSetting.earlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multArofeneSetting.earlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multArofeneSetting, "earlyUpperThreshold", $$v)
      },
      expression: "multArofeneSetting.earlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-025' || _vm.multSettingForm.deviceModel == 'YS-ZN-026' || _vm.multSettingForm.deviceModel == 'YS-ZN-003-PM') ? _c('el-form-item', {
    attrs: {
      "label": "告警参数:"
    }
  }, [_c('el-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("PM2.5 (ug/m³)")])], 1) : _vm._e(), _vm._v(" "), ((_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-025' || _vm.multSettingForm.deviceModel == 'YS-ZN-026' || _vm.multSettingForm.deviceModel == 'YS-ZN-003-PM') && (_vm.multSettingForm.alarmType == '0' || _vm.multSettingForm.alarmType == '-1' || _vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multPM25Setting.lowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multPM25Setting, "lowerThreshold", $$v)
      },
      expression: "multPM25Setting.lowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multPM25Setting.upperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multPM25Setting, "upperThreshold", $$v)
      },
      expression: "multPM25Setting.upperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-025' || _vm.multSettingForm.deviceModel == 'YS-ZN-026' || _vm.multSettingForm.deviceModel == 'YS-ZN-003-PM') && (_vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multPM25Setting.earlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multPM25Setting, "earlyLowerThreshold", $$v)
      },
      expression: "multPM25Setting.earlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multPM25Setting.earlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multPM25Setting, "earlyUpperThreshold", $$v)
      },
      expression: "multPM25Setting.earlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-026' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-VOC') ? _c('el-form-item', {
    attrs: {
      "label": "告警参数:"
    }
  }, [(_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-VOC') ? _c('el-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("TVOC (ppb)")]) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-026') ? _c('el-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("TVOC (ppm)")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), ((_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-026' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-VOC') && (_vm.multSettingForm.alarmType == '0' || _vm.multSettingForm.alarmType == '-1' || _vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multTOVCSetting.lowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multTOVCSetting, "lowerThreshold", $$v)
      },
      expression: "multTOVCSetting.lowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multTOVCSetting.upperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multTOVCSetting, "upperThreshold", $$v)
      },
      expression: "multTOVCSetting.upperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-026' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-VOC') && (_vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multTOVCSetting.earlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multTOVCSetting, "earlyLowerThreshold", $$v)
      },
      expression: "multTOVCSetting.earlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multTOVCSetting.earlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multTOVCSetting, "earlyUpperThreshold", $$v)
      },
      expression: "multTOVCSetting.earlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'AIoT-VTD01') ? _c('el-form-item', {
    attrs: {
      "label": "温度过高报警",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.multSettingForm.vtd01.overTemperatureSetting.warnType),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm.vtd01.overTemperatureSetting, "warnType", $$v)
      },
      expression: "multSettingForm.vtd01.overTemperatureSetting.warnType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不开启",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "报警",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "预警",
      "value": "-1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'AIoT-VTD01') ? _c('el-form-item', {
    attrs: {
      "label": "温度增幅过高报警",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.multSettingForm.vtd01.overTemperatureIncreaseSetting.warnType),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm.vtd01.overTemperatureIncreaseSetting, "warnType", $$v)
      },
      expression: "multSettingForm.vtd01.overTemperatureIncreaseSetting.warnType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不开启",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "报警",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "预警",
      "value": "-1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'AIoT-VTD01') ? _c('el-form-item', {
    attrs: {
      "label": "振动速度rms报警",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.multSettingForm.vtd01.vibrationRateSetting.warnType),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm.vtd01.vibrationRateSetting, "warnType", $$v)
      },
      expression: "multSettingForm.vtd01.vibrationRateSetting.warnType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不开启",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "报警",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "预警",
      "value": "-1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'AIoT-VTD01') ? _c('el-form-item', {
    attrs: {
      "label": "低频加速度rms报警",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.multSettingForm.vtd01.lowFrequencyRateSetting.warnType),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm.vtd01.lowFrequencyRateSetting, "warnType", $$v)
      },
      expression: "multSettingForm.vtd01.lowFrequencyRateSetting.warnType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不开启",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "报警",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "预警",
      "value": "-1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'AIoT-VTD01') ? _c('el-form-item', {
    attrs: {
      "label": "高频加速度rms报警",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.multSettingForm.vtd01.highFrequencyRateSetting.warnType),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm.vtd01.highFrequencyRateSetting, "warnType", $$v)
      },
      expression: "multSettingForm.vtd01.highFrequencyRateSetting.warnType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不开启",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "报警",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "预警",
      "value": "-1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'AIoT-VTD10') ? _c('el-form-item', {
    attrs: {
      "label": "温度过高报警",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.multSettingForm.vtd10.overTemperatureSetting.warnType),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm.vtd10.overTemperatureSetting, "warnType", $$v)
      },
      expression: "multSettingForm.vtd10.overTemperatureSetting.warnType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不开启",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "报警",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "预警",
      "value": "-1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'AIoT-VTD10') ? _c('el-form-item', {
    attrs: {
      "label": "温度增幅过高报警",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.multSettingForm.vtd10.overTemperatureIncreaseSetting.warnType),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm.vtd10.overTemperatureIncreaseSetting, "warnType", $$v)
      },
      expression: "multSettingForm.vtd10.overTemperatureIncreaseSetting.warnType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不开启",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "报警",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "预警",
      "value": "-1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'AIoT-VTD10') ? _c('el-form-item', {
    attrs: {
      "label": "振动速度rms报警",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.multSettingForm.vtd10.vibrationRateSetting.warnType),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm.vtd10.vibrationRateSetting, "warnType", $$v)
      },
      expression: "multSettingForm.vtd10.vibrationRateSetting.warnType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不开启",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "报警",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "预警",
      "value": "-1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'AIoT-VTD10') ? _c('el-form-item', {
    attrs: {
      "label": "振动加速度rms报警",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.multSettingForm.vtd10.vibrationAccelerateSetting.warnType),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm.vtd10.vibrationAccelerateSetting, "warnType", $$v)
      },
      expression: "multSettingForm.vtd10.vibrationAccelerateSetting.warnType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不开启",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "报警",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "预警",
      "value": "-1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'AIoT-VTD10') ? _c('el-form-item', {
    attrs: {
      "label": "振动位移峰峰值报警",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.multSettingForm.vtd10.vibrationMovePeakSetting.warnType),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm.vtd10.vibrationMovePeakSetting, "warnType", $$v)
      },
      expression: "multSettingForm.vtd10.vibrationMovePeakSetting.warnType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不开启",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "报警",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "预警",
      "value": "-1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "alarmTimeout",
      "label": "告警超时:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入1-3000的自然数"
    },
    model: {
      value: (_vm.multSettingForm.alarmTimeout),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm, "alarmTimeout", $$v)
      },
      expression: "multSettingForm.alarmTimeout"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("分钟")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelMultSettingSubmit($event)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.userRoleIdentity == 'admin') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.multSettingSubmitButtonDisabled,
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.multSettingSubmit($event)
      }
    }
  }, [_vm._v("提交")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看配置",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.cancelShowMultSettingSubmit
    },
    model: {
      value: (_vm.showMultSettingFormVisible),
      callback: function($$v) {
        _vm.showMultSettingFormVisible = $$v
      },
      expression: "showMultSettingFormVisible"
    }
  }, [_c('el-form', {
    ref: "settingForm",
    attrs: {
      "model": _vm.multSettingForm,
      "label-width": "160px",
      "rules": _vm.settingFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "传感器名称:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.multSettingForm.name))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "传感器类型:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.multSettingForm.deviceModelName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数据类型:",
      "prop": "dataType"
    }
  }, [(_vm.multSettingForm.dataType == 0) ? _c('span', [_vm._v("AI")]) : _c('span', [_vm._v("DI")])]), _vm._v(" "), (_vm.isYSZNDeviceType(_vm.multSettingForm.deviceModel)) ? _c('el-form-item', {
    attrs: {
      "label": "告警:",
      "prop": "alarmType"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.multSettingForm.alarmType),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm, "alarmType", $$v)
      },
      expression: "multSettingForm.alarmType"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "disabled": "",
      "label": 0
    }
  }, [_vm._v("报警")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "disabled": "",
      "label": -1
    }
  }, [_vm._v("预警")]), _vm._v(" "), (_vm.multSettingForm.dataType == '0') ? _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "disabled": "",
      "label": 1
    }
  }, [_vm._v("预警+报警")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-012-H2S') ? _c('el-form-item', {
    attrs: {
      "label": "告警参数:"
    }
  }, [_c('el-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("硫化氢浓度(ppm)")])], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-012-H2S' && (_vm.multSettingForm.alarmType == '0' || _vm.multSettingForm.alarmType == '-1' || _vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multH2SSetting.lowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multH2SSetting, "lowerThreshold", $$v)
      },
      expression: "multH2SSetting.lowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multH2SSetting.upperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multH2SSetting, "upperThreshold", $$v)
      },
      expression: "multH2SSetting.upperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-012-H2S' && (_vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multH2SSetting.earlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multH2SSetting, "earlyLowerThreshold", $$v)
      },
      expression: "multH2SSetting.earlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multH2SSetting.earlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multH2SSetting, "earlyUpperThreshold", $$v)
      },
      expression: "multH2SSetting.earlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-010-NH3') ? _c('el-form-item', {
    attrs: {
      "label": "告警参数:"
    }
  }, [_c('el-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("氨气浓度(ppm)")])], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-010-NH3' && (_vm.multSettingForm.alarmType == '0' || _vm.multSettingForm.alarmType == '-1' || _vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multNH3Setting.lowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multNH3Setting, "lowerThreshold", $$v)
      },
      expression: "multNH3Setting.lowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multNH3Setting.upperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multNH3Setting, "upperThreshold", $$v)
      },
      expression: "multNH3Setting.upperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-010-NH3' && (_vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multNH3Setting.earlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multNH3Setting, "earlyLowerThreshold", $$v)
      },
      expression: "multNH3Setting.earlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multNH3Setting.earlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multNH3Setting, "earlyUpperThreshold", $$v)
      },
      expression: "multNH3Setting.earlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-009-CO') ? _c('el-form-item', {
    attrs: {
      "label": "告警参数:"
    }
  }, [_c('el-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("一氧化碳浓度(ppm)")])], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-009-CO' && (_vm.multSettingForm.alarmType == '0' || _vm.multSettingForm.alarmType == '-1' || _vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multC0Setting.lowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multC0Setting, "lowerThreshold", $$v)
      },
      expression: "multC0Setting.lowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multC0Setting.upperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multC0Setting, "upperThreshold", $$v)
      },
      expression: "multC0Setting.upperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-009-CO' && (_vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multC0Setting.earlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multC0Setting, "earlyLowerThreshold", $$v)
      },
      expression: "multC0Setting.earlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multC0Setting.earlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multC0Setting, "earlyUpperThreshold", $$v)
      },
      expression: "multC0Setting.earlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-002-CO2') ? _c('el-form-item', {
    attrs: {
      "label": "告警参数:"
    }
  }, [_c('el-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("二氧化碳浓度(ppm)")])], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-002-CO2' && (_vm.multSettingForm.alarmType == '0' || _vm.multSettingForm.alarmType == '-1' || _vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multC02Setting.lowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multC02Setting, "lowerThreshold", $$v)
      },
      expression: "multC02Setting.lowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multC02Setting.upperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multC02Setting, "upperThreshold", $$v)
      },
      expression: "multC02Setting.upperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-002-CO2' && (_vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multC02Setting.earlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multC02Setting, "earlyLowerThreshold", $$v)
      },
      expression: "multC02Setting.earlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multC02Setting.earlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multC02Setting, "earlyUpperThreshold", $$v)
      },
      expression: "multC02Setting.earlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-10') ? _c('el-form-item', {
    attrs: {
      "label": "告警参数:"
    }
  }, [_c('el-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("温度（℃)")])], 1) : _vm._e(), _vm._v(" "), ((_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-10') && (_vm.multSettingForm.alarmType == '0' || _vm.multSettingForm.alarmType == '-1' || _vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multHeatSetting.lowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multHeatSetting, "lowerThreshold", $$v)
      },
      expression: "multHeatSetting.lowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multHeatSetting.upperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multHeatSetting, "upperThreshold", $$v)
      },
      expression: "multHeatSetting.upperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-10') && (_vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multHeatSetting.earlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multHeatSetting, "earlyLowerThreshold", $$v)
      },
      expression: "multHeatSetting.earlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multHeatSetting.earlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multHeatSetting, "earlyUpperThreshold", $$v)
      },
      expression: "multHeatSetting.earlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-10') ? _c('el-form-item', {
    attrs: {
      "label": "告警参数:"
    }
  }, [_c('el-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("湿度（%RH）")])], 1) : _vm._e(), _vm._v(" "), ((_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-10') && (_vm.multSettingForm.alarmType == '0' || _vm.multSettingForm.alarmType == '-1' || _vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multHumiditySetting.lowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multHumiditySetting, "lowerThreshold", $$v)
      },
      expression: "multHumiditySetting.lowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multHumiditySetting.upperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multHumiditySetting, "upperThreshold", $$v)
      },
      expression: "multHumiditySetting.upperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-10') && (_vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multHumiditySetting.earlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multHumiditySetting, "earlyLowerThreshold", $$v)
      },
      expression: "multHumiditySetting.earlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multHumiditySetting.earlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multHumiditySetting, "earlyUpperThreshold", $$v)
      },
      expression: "multHumiditySetting.earlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-025' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-10') ? _c('el-form-item', {
    attrs: {
      "label": "告警参数:"
    }
  }, [_c('el-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("甲醛容度 (ppb)")])], 1) : _vm._e(), _vm._v(" "), ((_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-025' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-10') && (_vm.multSettingForm.alarmType == '0' || _vm.multSettingForm.alarmType == '-1' || _vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multArofeneSetting.lowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multArofeneSetting, "lowerThreshold", $$v)
      },
      expression: "multArofeneSetting.lowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multArofeneSetting.upperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multArofeneSetting, "upperThreshold", $$v)
      },
      expression: "multArofeneSetting.upperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-025' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-10') && (_vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multArofeneSetting.earlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multArofeneSetting, "earlyLowerThreshold", $$v)
      },
      expression: "multArofeneSetting.earlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multArofeneSetting.earlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multArofeneSetting, "earlyUpperThreshold", $$v)
      },
      expression: "multArofeneSetting.earlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-025' || _vm.multSettingForm.deviceModel == 'YS-ZN-026' || _vm.multSettingForm.deviceModel == 'YS-ZN-003-PM') ? _c('el-form-item', {
    attrs: {
      "label": "告警参数:"
    }
  }, [_c('el-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("PM2.5 (ug/m³)")])], 1) : _vm._e(), _vm._v(" "), ((_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-025' || _vm.multSettingForm.deviceModel == 'YS-ZN-026' || _vm.multSettingForm.deviceModel == 'YS-ZN-003-PM') && (_vm.multSettingForm.alarmType == '0' || _vm.multSettingForm.alarmType == '-1' || _vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multPM25Setting.lowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multPM25Setting, "lowerThreshold", $$v)
      },
      expression: "multPM25Setting.lowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multPM25Setting.upperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multPM25Setting, "upperThreshold", $$v)
      },
      expression: "multPM25Setting.upperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-025' || _vm.multSettingForm.deviceModel == 'YS-ZN-026' || _vm.multSettingForm.deviceModel == 'YS-ZN-003-PM') && (_vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multPM25Setting.earlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multPM25Setting, "earlyLowerThreshold", $$v)
      },
      expression: "multPM25Setting.earlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multPM25Setting.earlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multPM25Setting, "earlyUpperThreshold", $$v)
      },
      expression: "multPM25Setting.earlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-026' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-VOC') ? _c('el-form-item', {
    attrs: {
      "label": "告警参数:"
    }
  }, [(_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-VOC') ? _c('el-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("TVOC (ppb)")]) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'YS-ZN-026') ? _c('el-radio', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("TVOC (ppm)")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), ((_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-026' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-VOC') && (_vm.multSettingForm.alarmType == '0' || _vm.multSettingForm.alarmType == '-1' || _vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline",
      "padding-bottom": "30px"
    },
    attrs: {
      "label": "正常范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multTOVCSetting.lowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multTOVCSetting, "lowerThreshold", $$v)
      },
      expression: "multTOVCSetting.lowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multTOVCSetting.upperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multTOVCSetting, "upperThreshold", $$v)
      },
      expression: "multTOVCSetting.upperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.multSettingForm.deviceModel == 'YS-ZN-024' || _vm.multSettingForm.deviceModel == 'YS-ZN-026' || _vm.multSettingForm.deviceModel == 'YS-ZN-004-VOC') && (_vm.multSettingForm.alarmType == '1')) ? _c('el-form-item', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "label": "预警范围:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multTOVCSetting.earlyLowerThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multTOVCSetting, "earlyLowerThreshold", $$v)
      },
      expression: "multTOVCSetting.earlyLowerThreshold"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "135px",
      "padding-bottom": "30px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.multTOVCSetting.earlyUpperThreshold),
      callback: function($$v) {
        _vm.$set(_vm.multTOVCSetting, "earlyUpperThreshold", $$v)
      },
      expression: "multTOVCSetting.earlyUpperThreshold"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'AIoT-VTD01') ? _c('el-form-item', {
    attrs: {
      "label": "温度过高报警",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.multSettingForm.vtd01.overTemperatureSetting.warnType),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm.vtd01.overTemperatureSetting, "warnType", $$v)
      },
      expression: "multSettingForm.vtd01.overTemperatureSetting.warnType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不开启",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "报警",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "预警",
      "value": "-1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'AIoT-VTD01') ? _c('el-form-item', {
    attrs: {
      "label": "温度增幅过高报警",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.multSettingForm.vtd01.overTemperatureIncreaseSetting.warnType),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm.vtd01.overTemperatureIncreaseSetting, "warnType", $$v)
      },
      expression: "multSettingForm.vtd01.overTemperatureIncreaseSetting.warnType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不开启",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "报警",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "预警",
      "value": "-1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'AIoT-VTD01') ? _c('el-form-item', {
    attrs: {
      "label": "振动速度rms报警",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.multSettingForm.vtd01.vibrationRateSetting.warnType),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm.vtd01.vibrationRateSetting, "warnType", $$v)
      },
      expression: "multSettingForm.vtd01.vibrationRateSetting.warnType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不开启",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "报警",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "预警",
      "value": "-1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'AIoT-VTD01') ? _c('el-form-item', {
    attrs: {
      "label": "低频加速度rms报警",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.multSettingForm.vtd01.lowFrequencyRateSetting.warnType),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm.vtd01.lowFrequencyRateSetting, "warnType", $$v)
      },
      expression: "multSettingForm.vtd01.lowFrequencyRateSetting.warnType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不开启",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "报警",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "预警",
      "value": "-1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'AIoT-VTD01') ? _c('el-form-item', {
    attrs: {
      "label": "高频加速度rms报警",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.multSettingForm.vtd01.highFrequencyRateSetting.warnType),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm.vtd01.highFrequencyRateSetting, "warnType", $$v)
      },
      expression: "multSettingForm.vtd01.highFrequencyRateSetting.warnType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不开启",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "报警",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "预警",
      "value": "-1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'AIoT-VTD10') ? _c('el-form-item', {
    attrs: {
      "label": "温度过高报警",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.multSettingForm.vtd10.overTemperatureSetting.warnType),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm.vtd10.overTemperatureSetting, "warnType", $$v)
      },
      expression: "multSettingForm.vtd10.overTemperatureSetting.warnType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不开启",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "报警",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "预警",
      "value": "-1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'AIoT-VTD10') ? _c('el-form-item', {
    attrs: {
      "label": "温度增幅过高报警",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.multSettingForm.vtd10.overTemperatureIncreaseSetting.warnType),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm.vtd10.overTemperatureIncreaseSetting, "warnType", $$v)
      },
      expression: "multSettingForm.vtd10.overTemperatureIncreaseSetting.warnType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不开启",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "报警",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "预警",
      "value": "-1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'AIoT-VTD10') ? _c('el-form-item', {
    attrs: {
      "label": "振动速度rms报警",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.multSettingForm.vtd10.vibrationRateSetting.warnType),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm.vtd10.vibrationRateSetting, "warnType", $$v)
      },
      expression: "multSettingForm.vtd10.vibrationRateSetting.warnType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不开启",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "报警",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "预警",
      "value": "-1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'AIoT-VTD10') ? _c('el-form-item', {
    attrs: {
      "label": "振动加速度rms报警",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.multSettingForm.vtd10.vibrationAccelerateSetting.warnType),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm.vtd10.vibrationAccelerateSetting, "warnType", $$v)
      },
      expression: "multSettingForm.vtd10.vibrationAccelerateSetting.warnType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不开启",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "报警",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "预警",
      "value": "-1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.multSettingForm.deviceModel == 'AIoT-VTD10') ? _c('el-form-item', {
    attrs: {
      "label": "振动位移峰峰值报警",
      "prop": "explainModel"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.multSettingForm.vtd10.vibrationMovePeakSetting.warnType),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm.vtd10.vibrationMovePeakSetting, "warnType", $$v)
      },
      expression: "multSettingForm.vtd10.vibrationMovePeakSetting.warnType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "不开启",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "报警",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "预警",
      "value": "-1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "alarmTimeout",
      "label": "告警超时:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off",
      "placeholder": "请输入1-3000的自然数"
    },
    model: {
      value: (_vm.multSettingForm.alarmTimeout),
      callback: function($$v) {
        _vm.$set(_vm.multSettingForm, "alarmTimeout", $$v)
      },
      expression: "multSettingForm.alarmTimeout"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "40px",
      "text-align": "right",
      "vertical-align": "middle",
      "font-size": "14px",
      "color": "grey",
      "line-height": "1",
      "padding": "10px 10px 10px 10px",
      "box-sizing": "border-box"
    }
  }, [_vm._v("分钟")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelShowMultSettingSubmit($event)
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62be6fc6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/assets_manage/terminal_list.vue
// module id = 846
// module chunks = 1